/* eslint-disable */
import { jsPDF } from 'jspdf';
import _ from 'lodash';
import translations from '../constants/translations';

const formUtils = {};

formUtils.required = (language) => {
  return value => value ? undefined : _.get(translations, `${language}.required`);
}

formUtils.formatOptions = (opt) => (
  opt.map((o) => ({ label: o.display_name, value: o.value }))
);

formUtils.generatePDFDynamic = async ({
  base64SignatureImage,
  fullName,
  htmlContent,
  contactFullName,
}) => {
  const doc = new jsPDF("p", "pt", "a4");
  await doc.html(htmlContent, {
    x: 30,
    y: 10,
    windowWidth: 760,
    width: 760,
    html2canvas: {
      onclone: function (clonedDoc, clonedReference) {
        clonedDoc.body.style.color = '#000';
        clonedDoc.body.style.fontSize = '40px';
        clonedDoc.body.style.fontFamily = 'Helvetiva,Arial,sans-serif';
        const title = clonedReference.querySelector('h3');
        title.style.fontWeight = 'bold';
        title.style.fontSize = '24px';
        clonedReference.querySelectorAll('a').forEach((e) => {
          e.style.color = '#000';
        });
      },
      scrollY: 0,
      scale: 0.70,
    },
  });

  // --- signature
  doc.addImage(base64SignatureImage, 'PNG', 50, 220, 240, 80, '', 'FAST');

  doc.setDrawColor('#000');
  doc.setLineWidth(1);
  doc.line(35, 290, 200, 290);

  doc.setTextColor('#000');
  doc.setFontSize(10);
  doc.text(fullName.toUpperCase(), 35, 305);

  // --- date
  const today = new Date();
  var dateUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), today.getUTCHours(), today.getUTCMinutes()));
  const dateStr = dateUTC.toLocaleTimeString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
    timeZoneName: 'short',
  });

  doc.setFontSize(9);
  doc.text(contactFullName, 90, 304)
  doc.text(dateStr, 35, 315);
  const formattedPdf =  new Blob([ doc.output('blob') ], { type : 'application/pdf'});

  return formattedPdf;
};

export default formUtils;
